import type { ReactNode } from 'react'

export type IconProps = {
  /** Rendered size in px (both width and height). Defaults to 24. */
  size?: number
  className?: string
}

type IconSvgProps = IconProps & {
  children: ReactNode
}

/**
 * Shared SVG shell for every RUST line icon: 24×24 viewBox, stroke-width 1.8,
 * round caps/joins, transparent background, currentColor stroke.
 * Icons are decorative by default (aria-hidden) — always render a visible
 * text label next to them.
 */
export function IconSvg({ size = 24, className, children }: IconSvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      {children}
    </svg>
  )
}
